var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBPenFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-pen-frame",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-pen-frame1",
    serifid: "iconB-pen-frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11,3c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-4.2,0c-1.436,0 -2.16,-0.061 -2.708,0.218c-0.376,0.192 -0.682,0.498 -0.874,0.874c-0.279,0.548 -0.218,1.272 -0.218,2.708l0,8.4c0,1.436 -0.061,2.159 0.218,2.708c0.192,0.376 0.498,0.682 0.874,0.874c0.548,0.279 1.272,0.218 2.708,0.218l8.4,0c1.436,0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.549 0.218,-1.272 0.218,-2.708l0,-4.2c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,4.2c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-8.4,0c-1.925,0 -2.881,-0.061 -3.616,-0.436c-0.753,-0.383 -1.365,-0.995 -1.748,-1.748c-0.375,-0.735 -0.436,-1.691 -0.436,-3.616l0,-8.4c0,-1.925 0.061,-2.881 0.436,-3.616c0.383,-0.753 0.995,-1.365 1.748,-1.748c0.735,-0.375 1.691,-0.436 3.616,-0.436l4.2,0Zm-4,13l0,-1.675c0,-0.608 0.014,-0.911 0.083,-1.197c0.073,-0.306 0.195,-0.599 0.359,-0.867c0.154,-0.251 0.358,-0.475 0.788,-0.905l9.563,-9.563c1.219,-1.219 3.195,-1.219 4.414,-0c1.219,1.219 1.219,3.195 0,4.414l-9.563,9.563c-0.43,0.43 -0.654,0.634 -0.905,0.788c-0.268,0.164 -0.561,0.286 -0.867,0.359c-0.286,0.069 -0.589,0.083 -1.197,0.083l-1.675,0c-0.552,0 -1,-0.448 -1,-1Zm2,-1l0.675,0c0.37,0 0.556,0.014 0.73,-0.028c0.102,-0.024 0.2,-0.065 0.289,-0.119c0.153,-0.094 0.274,-0.236 0.536,-0.497l9.563,-9.563c0.438,-0.438 0.438,-1.148 0,-1.586c-0.438,-0.438 -1.148,-0.438 -1.586,0l-9.563,9.563c-0.262,0.262 -0.403,0.383 -0.497,0.536c-0.054,0.089 -0.095,0.187 -0.119,0.289c-0.042,0.174 -0.028,0.36 -0.028,0.731l0,0.674Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBPenFrame);
export default __webpack_public_path__ + "static/media/iconB-pen-frame.77f79df89078697c9751507ceb634ab9.svg";
export { ForwardRef as ReactComponent };